import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { FirestoreRange } from '../interfaces/firestore-range';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductSelectorService {

  dropDownOptions: Array<any> = [];
  private currentProduct = new BehaviorSubject<any>(null);
  public products$: AngularFirestoreCollection<any>;

  constructor(
    private database: AngularFirestore
  ) {
    this.products$ = this.database.collection<FirestoreRange>('products');
  }

  get products() {
    return this.products$.valueChanges();
  }

  get selectedProduct() {
    return this.currentProduct.asObservable();
  }

  set selectedProduct(products) {
    this.currentProduct.next(products);
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
}
